export const MAX_DOGS_FIELD_KEY = 'max_dogs_per_booking';
export const DEFAULT_MAX_ADDITIONAL_DOGS = 15;

/**
 * Resolve max additional dogs for a listing from its `max_dogs_per_booking`
 * public-data field. The base booking includes the first dog, so additional =
 * total - 1. Falls back to the default when unset/invalid.
 *
 * @param {Object} publicData listing public data
 * @returns {number} max additional dogs
 */
export const resolveMaxAdditionalDogs = publicData => {
  const raw = publicData?.[MAX_DOGS_FIELD_KEY];
  const parsed = typeof raw === 'number' ? raw : raw != null ? parseInt(raw, 10) : NaN;
  return Number.isFinite(parsed) && parsed > 0
    ? Math.max(0, parsed - 1)
    : DEFAULT_MAX_ADDITIONAL_DOGS;
};
